import api from '../../plugins/api';

// Выгрузки сторов (CSV из App Store Connect и Google Play), FormData с полем files
const importAppInstalls = (formData) => {
  return api.uploadFile('/api/crm/reports/app-installs/import', formData);
};

export default importAppInstalls;
